import { DateTime } from 'luxon';

export function isUsingNextDayTimes(loungeLocalTime, loungeOpening) {
  return loungeLocalTime.startOf('day') < loungeOpening.startOf('day');
}

export function isBetweenTimes(queryLuxon, luxonBefore, luxonAfter) {
  return luxonBefore < queryLuxon && queryLuxon < luxonAfter;
}

export function getLangFromLocale(locale) {
  return locale.split('-')[0].split('_')[0];
}

export function removeTimeWhiteSpace(value) {
  if (typeof value !== 'string') return value;
  return value.replace(/\s+/g, '');
}

export function getCurrentTimeForTimeZone(locale, timeZone) {
  return typeof locale === 'undefined'
    ? DateTime.now().setZone(timeZone).setLocale('en')
    : DateTime.now().setZone(timeZone).setLocale(getLangFromLocale(locale));
}

export function getCurrentDayForTimeZone(locale, timeZone) {
  return getCurrentTimeForTimeZone(locale, timeZone)
    .toFormat('cccc')
    .toLowerCase();
}

export function parseLoungeLuxonFromTimeString(timeString, loungeTimeZone) {
  if (!timeString) {
    return DateTime.invalid('Invalid timeString');
  }
  return DateTime.fromFormat(timeString, 'HHmm', {
    zone: loungeTimeZone,
  });
}

export function formatLoungeTimeFromTimeString({
  timeString,
  loungeTimeZone,
  format,
  locale,
}) {
  return removeTimeWhiteSpace(
    parseLoungeLuxonFromTimeString(timeString, loungeTimeZone)
      .setLocale(getLangFromLocale(locale))
      .toFormat(format)
  );
}

export function formatLoungeTimeFromLuxonObj({
  loungeTimeLuxon,
  format,
  locale,
}) {
  return removeTimeWhiteSpace(
    loungeTimeLuxon
      .toFormat(format)
      .toLocaleLowerCase(getLangFromLocale(locale))
  );
}

export function isValidTime(timeStr) {
  if (!/^\d{4}$/.test(timeStr)) return false;
  const hours = Number.parseInt(timeStr.slice(0, 2), 10);
  const minutes = Number.parseInt(timeStr.slice(2), 10);
  return hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59;
}
